const CLAVE = 'atencionBorrador'

function leer() {
    try {
        return JSON.parse(localStorage.getItem(CLAVE) || 'null')
    } catch (error) {
        return null
    }
}

function escribir(borrador) {
    localStorage.setItem(CLAVE, JSON.stringify(borrador))
}

export function limpiarBorrador() {
    localStorage.removeItem(CLAVE)
    localStorage.removeItem('recetaData')
}

export function sincronizarPaciente(codPaciente, codConsulta) {
    const actual = leer()
    const mismoPaciente = actual && actual.codPaciente === codPaciente

    if (!mismoPaciente) {
        const nuevo = {
            codPaciente: codPaciente || '',
            codConsulta: codConsulta || '',
            diagnosticos: []
        }
        if (actual) {
            limpiarBorrador()
        } else {
            localStorage.removeItem('recetaData')
        }
        escribir(nuevo)
        return { ...nuevo, reiniciado: true }
    }

    const siguiente = {
        ...actual,
        codConsulta: codConsulta || actual.codConsulta,
        diagnosticos: Array.isArray(actual.diagnosticos) ? actual.diagnosticos : []
    }
    escribir(siguiente)
    return { ...siguiente, reiniciado: false }
}

export function guardarDiagnosticos(codPaciente, codConsulta, diagnosticos) {
    const actual = leer()
    const base = actual && actual.codPaciente === codPaciente
        ? actual
        : { codPaciente: codPaciente || '', codConsulta: codConsulta || '', diagnosticos: [] }

    escribir({
        ...base,
        codPaciente: codPaciente || base.codPaciente,
        codConsulta: codConsulta || base.codConsulta,
        diagnosticos: (diagnosticos || []).map((item) => ({
            Codigo: item.Codigo || item.codigo || '',
            Descriptor: item.Descriptor || item.nombre || '',
            tipo: item.tipo || '',
            descripcion: item.descripcion || '',
            cieID: item.cieID || ''
        }))
    })
}

export function guardarSeccion(codPaciente, codConsulta, seccion, datos) {
    const actual = leer()
    const base = actual && actual.codPaciente === codPaciente
        ? actual
        : { codPaciente: codPaciente || '', codConsulta: codConsulta || '', diagnosticos: [], secciones: {} }

    escribir({
        ...base,
        codPaciente: codPaciente || base.codPaciente,
        codConsulta: codConsulta || base.codConsulta,
        secciones: {
            ...(base.secciones || {}),
            [seccion]: datos
        }
    })
}

export function leerSeccion(codPaciente, seccion) {
    const actual = leer()
    if (!actual || actual.codPaciente !== codPaciente) return null
    const secciones = actual.secciones || {}
    return Object.prototype.hasOwnProperty.call(secciones, seccion) ? secciones[seccion] : null
}

export function leerDiagnosticos(codPaciente) {
    const actual = leer()
    if (!actual || actual.codPaciente !== codPaciente) return []
    return Array.isArray(actual.diagnosticos) ? actual.diagnosticos : []
}
